import { collectionGroup, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';

const toDate = (v) => (v && typeof v.toDate === 'function' ? v.toDate() : v ? new Date(v) : null);

// Every tournament a user has a `players` doc in, newest-first by end date.
export const listUserTournaments = async (uid) => {
  if (!uid) return [];

  const snap = await getDocs(query(collectionGroup(db, 'players'), where('userId', '==', uid)));

  // A user can end up with multiple player docs in the same tournament
  // (e.g. duplicate roster entries) — keep only the first per tournament.
  const playerByTournament = new Map();
  snap.docs.forEach((d) => {
    const tournamentId = d.ref.parent.parent?.id;
    if (tournamentId && !playerByTournament.has(tournamentId)) {
      playerByTournament.set(tournamentId, d.data());
    }
  });

  const entries = await Promise.all(
    [...playerByTournament.entries()].map(async ([tournamentId, playerData]) => {
      const tSnap = await getDoc(doc(db, 'tournaments', tournamentId));
      if (!tSnap.exists()) return null; // parent tournament deleted
      return { id: tournamentId, ...tSnap.data(), playerProfile: playerData };
    })
  );

  return entries
    .filter(Boolean)
    .sort((a, b) => (toDate(b.endDate) || 0) - (toDate(a.endDate) || 0));
};
